module.exports = __webpack_public_path__ + "media/科技城.616e5cbf.mp4";